export default __webpack_public_path__ + "static/media/GHSI Whistle-Blowing Policy.d65e5bc5.pdf";